"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationDefaultContentBuilder = void 0;
var abstract_builder_1 = require("./abstract-builder");
var notification_default_content_1 = require("../structs/notification-default-content");
var NotificationDefaultContentBuilder = (function (_super) {
    __extends(NotificationDefaultContentBuilder, _super);
    function NotificationDefaultContentBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Model = notification_default_content_1.NotificationDefaultContent;
        return _this;
    }
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "title", {
        get: function () {
            return this.data.title;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setTitle = function (title) {
        this.data.title = title;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "body", {
        get: function () {
            return this.data.body;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setBody = function (body) {
        this.data.body = body;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "iconUrl", {
        get: function () {
            return this.data.iconUrl;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setIconUrl = function (iconUrl) {
        this.data.iconUrl = iconUrl;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "imageUrl", {
        get: function () {
            return this.data.imageUrl;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setImageUrl = function (imageUrl) {
        this.data.imageUrl = imageUrl;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "badgeUrl", {
        get: function () {
            return this.data.badgeUrl;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setBadgeUrl = function (badgeUrl) {
        this.data.badgeUrl = badgeUrl;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "landingUrl", {
        get: function () {
            return this.data.landingUrl;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setLandingUrl = function (landingUrl) {
        this.data.landingUrl = landingUrl;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "actions", {
        get: function () {
            return this.data.actions;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setActions = function (actions) {
        this.data.actions = Array.from(actions);
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "altNativeUrl", {
        get: function () {
            return this.data.altNativeUrl;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setAltNativeUrl = function (url) {
        this.data.altNativeUrl = url;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "autoSuggestedFieldsResults", {
        get: function () {
            return this.data.autoSuggestedFieldsResults;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setAutoSuggestedFieldsResults = function (autoSuggestedFieldsResults) {
        this.data.autoSuggestedFieldsResults = autoSuggestedFieldsResults;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "channels", {
        get: function () {
            return this.data.channels;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setChannels = function (channels) {
        this.data.channels = channels.length ? Array.from(channels) : undefined;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "contentWebhookUrl", {
        get: function () {
            return this.data.contentWebhookUrl;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setContentWebhookUrl = function (url) {
        this.data.contentWebhookUrl = url;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "createdAt", {
        get: function () {
            return this.data.createdAt;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setCreatedAt = function (date) {
        this.data.createdAt = date;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "isSilent", {
        get: function () {
            return this.data.isSilent;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setIsSilent = function (isSilent) {
        this.data.isSilent = isSilent;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "isUserTemplate", {
        get: function () {
            return this.data.isUserTemplate;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setIsUserTemplate = function (isUserTemplate) {
        this.data.isUserTemplate = isUserTemplate;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "isUsingDomainDefaultBadge", {
        get: function () {
            return this.data.isUsingDomainDefaultBadge;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setIsUsingDomainDefaultBadge = function (isUsingDomainDefaultBadge) {
        this.data.isUsingDomainDefaultBadge = isUsingDomainDefaultBadge;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "isUsingDomainDefaultIcon", {
        get: function () {
            return this.data.isUsingDomainDefaultIcon;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setIsUsingDomainDefaultIcon = function (isUsingDomainDefaultIcon) {
        this.data.isUsingDomainDefaultIcon = isUsingDomainDefaultIcon;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "keywords", {
        get: function () {
            return this.data.keywords;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setKeywords = function (keywords) {
        this.data.keywords = keywords;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "overrideDefaultActions", {
        get: function () {
            return this.data.overrideDefaultActions;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setOverrideDefaultActions = function (shouldOverride) {
        this.data.overrideDefaultActions = shouldOverride;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "overrideFallbackTemplate", {
        get: function () {
            return this.data.overrideFallbackTemplate;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setOverrideFallbackTemplate = function (shouldOverride) {
        this.data.overrideFallbackTemplate = shouldOverride;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "requireInteraction", {
        get: function () {
            return this.data.requireInteraction;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setRequireInteraction = function (require) {
        this.data.requireInteraction = require;
        return this;
    };
    Object.defineProperty(NotificationDefaultContentBuilder.prototype, "updatedAt", {
        get: function () {
            return this.data.updatedAt;
        },
        enumerable: false,
        configurable: true
    });
    NotificationDefaultContentBuilder.prototype.setUpdatedAt = function (date) {
        this.data.updatedAt = date;
        return this;
    };
    return NotificationDefaultContentBuilder;
}(abstract_builder_1.AbstractBuilder));
exports.NotificationDefaultContentBuilder = NotificationDefaultContentBuilder;
//# sourceMappingURL=notification-default-content-builder.js.map